import { useSelector } from "react-redux";
import classes from "./RegistrationStatus.module.scss";

export default function RegistrationStatus() {
  const userStatus =
    useSelector((state) => state.auth.userStatus) || "INCOMPLETE";
  const messages = {
    INCOMPLETE:
      "Kindly check the email address you provided during registration for a message containing a link to complete the registration process. Please follow the link to finalize your registration.",
    PENDING:
      "Your request is currently under review and pending confirmation from the COP29 MDS Team. You will be notified via email once the confirmation is complete.",
    SUSPENDED: "Your account is suspended.",
  };
  return (
    <div className={classes.container}>
      <div
        className={`${classes.message} ${
          userStatus === "SUSPENDED" ? classes.suspended : ""
        }`}
      >
        {messages[userStatus]}
      </div>
    </div>
  );
}
